<script setup>
import {ref} from 'vue'
import SocialMediaButton from "@/Pages/Auth/Components/SocialMediaButton.vue"

const mediaLinks = ref({
    'mdi-facebook': 'https://www.facebook.com/profile.php?id=61579131811650&locale=pt_BR',
    'mdi-youtube': 'https://www.youtube.com/channel/UComlhLGllvp_WlLj6eJkSiA',
    'mdi-linkedin': 'https://www.linkedin.com/company/creative-design_3',
    'mdi-instagram': 'https://www.instagram.com/creativedesignbr/'
})

</script>

<template>
    <v-footer color="secondary">
        <v-container>
            <v-row class="pt-8">
                <v-col class="d-flex justify-center">
                    <SocialMediaButton
                        v-for="(link, icon) in mediaLinks"
                        :key="icon"
                        :icon="icon"
                        :link="link"
                        class="mx-4"
                        size="40"
                        variant="plain"
                    ></SocialMediaButton>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex justify-center">
                    <p>© {{ new Date().getFullYear() }} <strong> Creative Design. Todos direitos reservados.</strong></p>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

